// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__3cCxR","greeting":"List_greeting__2FfPQ"};